import { match } from 'ts-pattern'

import { reatomPair } from '@root/entities/pair/atoms'

import type { ServicesPoolsGetCookingPoolsCreatePayload } from '@blade/trade-api-client'
import type { Ctx } from '@reatom/framework'
import type { PairMetrics } from '@root/entities/pair/model'

type ExplorePoolFiltersDto = NonNullable<
  ServicesPoolsGetCookingPoolsCreatePayload['filters']
>
type ExplorePoolSortBy = NonNullable<ExplorePoolFiltersDto['sortBy']>

export type ExploreSortingField = ExplorePoolSortBy

export const sortingToOrder =
  (
    sorting: { sortBy: ExploreSortingField; sortDir: 'asc' | 'desc' },
    period: PairMetrics.MetricsSpan,
  ) =>
  (ctx: Ctx) => {
    return match(sorting)
      .with({ sortBy: 'marketCapUsd', sortDir: 'asc' }, () =>
        reatomPair.cmpByMarketCapAsc(ctx),
      )
      .with({ sortBy: 'marketCapUsd', sortDir: 'desc' }, () =>
        reatomPair.cmpByMarketCapDesc(ctx),
      )
      .with({ sortBy: 'liquidityInUsd', sortDir: 'asc' }, () =>
        reatomPair.cmpByLiquidityAsc(ctx),
      )
      .with({ sortBy: 'liquidityInUsd', sortDir: 'desc' }, () =>
        reatomPair.cmpByLiquidityDesc(ctx),
      )
      .with({ sortBy: 'volumeInUsd', sortDir: 'asc' }, () =>
        reatomPair.cmpByVolumeUsdAsc(period)(ctx),
      )
      .with({ sortBy: 'volumeInUsd', sortDir: 'desc' }, () =>
        reatomPair.cmpByVolumeUsdDesc(period)(ctx),
      )
      .with({ sortBy: 'netVolumeInUsd', sortDir: 'asc' }, () =>
        reatomPair.cmpByNetVolumeUsdAsc(period)(ctx),
      )
      .with({ sortBy: 'netVolumeInUsd', sortDir: 'desc' }, () =>
        reatomPair.cmpByNetVolumeUsdDesc(period)(ctx),
      )
      .with({ sortBy: 'txCount', sortDir: 'asc' }, () =>
        reatomPair.cmpByTxCountAsc(period)(ctx),
      )
      .with({ sortBy: 'txCount', sortDir: 'desc' }, () =>
        reatomPair.cmpByTxCountDesc(period)(ctx),
      )
      .with(
        { sortBy: 'createdAt', sortDir: 'asc' },
        () => reatomPair.cmpByCreatedAtAsc,
      )
      .with(
        { sortBy: 'createdAt', sortDir: 'desc' },
        () => reatomPair.cmpByCreatedAtDesc,
      )
      .with({ sortBy: 'holdersChangePercents', sortDir: 'asc' }, () =>
        reatomPair.cmpByHoldersChangePercentsAsc(period)(ctx),
      )
      .with({ sortBy: 'holdersChangePercents', sortDir: 'desc' }, () =>
        reatomPair.cmpByHoldersChangePercentsDesc(period)(ctx),
      )
      .with({ sortBy: 'holdersCount', sortDir: 'asc' }, () =>
        reatomPair.cmpByHoldersCountAsc(ctx),
      )
      .with({ sortBy: 'holdersCount', sortDir: 'desc' }, () =>
        reatomPair.cmpByHoldersCountDesc(ctx),
      )
      .with({ sortBy: 'priceChangePercents', sortDir: 'asc' }, () =>
        reatomPair.cmpByPriceChangePercentsAsc(period)(ctx),
      )
      .with({ sortBy: 'priceChangePercents', sortDir: 'desc' }, () =>
        reatomPair.cmpByPriceChangePercentsDesc(period)(ctx),
      )
      .with({ sortBy: 'gainScore', sortDir: 'asc' }, () => undefined)
      .with({ sortBy: 'gainScore', sortDir: 'desc' }, () => undefined)
      .with(
        { sortBy: 'extraDetails.migration.migrationTimestamp' },
        () => undefined,
      )
      .exhaustive()
  }
